import { render } from "./TabPlantPowerFlowHub.vue?vue&type=template&id=b2fe786c"
import script from "./TabPlantPowerFlowHub.vue?vue&type=script&lang=js"
export * from "./TabPlantPowerFlowHub.vue?vue&type=script&lang=js"

import "./TabPlantPowerFlowHub.vue?vue&type=style&index=0&id=b2fe786c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__